<template>
  <section class="py-20 bg-white">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <div class="text-title font-bold text-[#333333] leading-tight mb-6">
          Certifications & Accreditations
        </div>
      </div>
      <div class="grid grid-cols-1 gap-8 text-center">
        <div class="w-[70%] mx-auto">
          <img class="rounded-[16px]" src="@/assets/web_pg_ca.png" alt="">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  data () {
    return {
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/statisticsSection.vue